import ExcelJS from 'exceljs'

class ExcelGenerator {
  constructor(filename, urn, guid) {
    this.workbook = new ExcelJS.Workbook()
    this.worksheet = this.workbook.addWorksheet('Sheet 1')
    this.filename = filename || 'export.xlsx'
    this.urn = urn || ''
    this.guid = guid || ''
    this.headers = []
  }

  generateHeader(properties) {
    const uniqueProperties = [
      ...new Set(
        properties.map((property) => Object.keys(property.properties)).flat()
      ),
    ]

    const headerNames = ['urn', 'vista', 'dbId', ...uniqueProperties]
    this.headers = [...uniqueProperties]

    const headerRow = this.worksheet.getRow(1)
    headerRow.values = [...headerNames]
    return uniqueProperties
  }

  generateRows(data) {
    const rows = data.map((item) => {
      const row = [this.urn, this.guid, item.dbId]
      this.headers.forEach((header) => {
        if (item.properties.hasOwnProperty(header)) {
          row.push(item.properties[header])
        } else {
          row.push(' ')
        }
      })

      return row
    })

    rows.forEach((rowData, index) => {
      const row = this.worksheet.getRow(index + 2)
      row.values = rowData
    })
  }

  async generateExcel(data) {
    this.generateHeader(data.data)
    this.generateRows(data.data)

    const buffer = await this.workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = this.filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }
}

export default ExcelGenerator
